import { ref, watch, computed } from 'vue'
import { http } from '../../../utils/index'
import { getTreeNode } from '../util/index'
import { useDispatch } from '../../../hooks/index'
import { useFormItemValidate } from '../../form/hook/use-form-item-validate'

export function useDisplay(props, request) {
  const visible = ref(false)
  const showRander = ref(false)
  const showEvent = () => {
    if (!showRander.value) {
      showRander.value = true
    }
    visible.value = true
  }
  const onCancel = () => {
    visible.value = false
  }

  const requestKey = computed(() => props.requestDataKey ?? props.selectionKey)

  const showSelections = ref([])
  let list = []

  const { dispatch } = useDispatch()
  const { formItemsChange } = useFormItemValidate()
  watch(
    () => props.value,
    async () => {
      //当value的值发生变化时隐藏弹窗
      visible.value = false
      //兼容pangu-components的表单触发校验
      if (props.store) {
        dispatch('FormItem', 'on-form-blur', null)
        dispatch('FormItem', 'on-form-change', null)
      } else {
        formItemsChange()
      }

      if (request === undefined) {
        return
      }
      if (!request) {
        if (!props.value || props.valueIsObj) {
          showSelections.value = props.value
        } else {
          showSelections.value = props.multiple
            ? props.value.map((im) => ({ [props.showKey]: im }))
            : { [props.showKey]: props.value }
        }
        return
      }

      if (list.length === 0 && props.value && !props.valueIsObj) {
        const [res] = await http[props.method](props.url, props.paramater)
        list = res?.data ?? []
      }

      if (!props.value || props.valueIsObj) {
        showSelections.value = props.value
      } else if (props.multiple) {
        showSelections.value = props.value.reduce((pre, cur) => {
          const item = getTreeNode(
            list,
            props.valueIsObj ? cur[props.selectionKey] : cur,
            requestKey.value
          )
          if (item) {
            pre.push(item)
          }
          return pre
        }, [])
      } else {
        showSelections.value = getTreeNode(
          list,
          props.valueIsObj ? props.value[props.selectionKey] : props.value,
          requestKey.value
        )
      }
    },
    {
      immediate: true,
    }
  )

  return {
    visible,
    showRander,
    showEvent,
    onCancel,
    showSelections,
    requestKey,
  }
}
